import React from 'react'
//import img from '../Images/sunset.jpg'
import { Zoom, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Home = ({ userdata, activeData }) => {
    function copyContent() {

        let element = document.getElementById('p1');
        let htmlContent = element.innerHTML;
        const type = "text/html"
        const text = htmlContent
        const blob = new Blob([text], { type });
        const data = [new ClipboardItem({ [type]: blob })];
        navigator.clipboard.write(data)
            .then(() => {
                toast.success("Copied successfully!", {
                    autoClose: 1500,
                    position: "top-right",
                    transition: Zoom
                });
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
                alert("Failed to copy");
            });
    }
    return (

        <div className='container-fluid'>

            <h1 className='mail-h1' >Generated Signature</h1>

            <div className="mail-box" id="p1" style={{ direction: 'ltr', height: '100%', width: '100%', display: 'flex', justifyContent: 'center' }}>
                <table
                    cellSpacing="0"
                    cellPadding="0"
                    style={{ backgroundColor: '#fff', borderRadius: '9px', }}
                    dir="ltr"
                >
                    <tbody>
                        <tr>
                            <td colSpan="4" height="20"></td>
                        </tr>
                        <tr>
                            <td width="5"></td>
                            <td width={200}>
                                <table cellSpacing="0" cellPadding="0">
                                    <tbody>
                                        <tr style={{ textAlign: 'center',height:100 }}>
                                            <td>
                                                <img
                                                    className='img-uhy-fluid'
                                                    src={process.env.PUBLIC_URL + '/IMG_8039.png'}
                                                    alt="logo"
                                                    width={200}
                                                    style={{ width: 200 }}
                                                />
                                            </td>
                                        </tr>

                                        <tr style={{ textAlign: '-webkit-center' }}>
                                            <td valign='middle' align='center'>
                                                <table
                                                    cellSpacing="0"
                                                    cellPadding="0"
                                                    style={{ marginLeft: 0 }}
                                                    className='socail-icon-tab'
                                                >
                                                    <tbody>
                                                        <tr style={{ textAlign: 'center' }}>
                                                            {[
                                                                {
                                                                    href: 'https://www.linkedin.com/company/101637309',
                                                                    src: process.env.PUBLIC_URL + "linkedin.png",
                                                                    style: { width: 26 }, width: 26
                                                                },
                                                                {
                                                                    href: 'https://x.com/AlUhy36349',
                                                                    src: process.env.PUBLIC_URL + "twitter.png",
                                                                    style: { width: 25, }, width: 25
                                                                },

                                                                {
                                                                    href: 'https://www.instagram.com/uhy_almousa/',
                                                                    src: process.env.PUBLIC_URL + "instaicon.png",
                                                                    style: { width: 26 }, width: 26
                                                                },
                                                                {
                                                                    href: 'https://www.facebook.com/profile.php?id=61571394376421',
                                                                    src: process.env.PUBLIC_URL + "fackbook.png",
                                                                    style: { width: 26 }, width: 26
                                                                },

                                                            ].map((item, idx) => (
                                                                <React.Fragment key={idx}>
                                                                    <td width="5">
                                                                        <div></div>
                                                                    </td>
                                                                    <td>
                                                                        <a href={item.href} target="_blank" rel="noreferrer">
                                                                            <img style={item.style} src={item.src} width={item.width} alt="" />
                                                                        </a>
                                                                    </td>
                                                                </React.Fragment>
                                                            ))}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>

                            <td style={{ padding: '0px 0px 0px 15px', verticalAlign: 'top' }}>
                                <table cellSpacing="0" cellPadding="0">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span
                                                    className="myname"
                                                    style={{
                                                        fontFamily: 'system-ui',
                                                        fontSize: '10pt',
                                                        fontWeight: 'bold',
                                                        color: '#007540',
                                                    }}
                                                >
                                                    {userdata.name}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '9pt',
                                                    color: '#007540',
                                                    lineHeight: '16px',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                <span className="mypostion">{userdata.position}</span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                <span className="mymob">{userdata.number}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px', fontWeight: "bolder"
                                                }}
                                            >
                                                <span className="subtitle">{activeData.subtitle}</span>
                                            </td>
                                        </tr>

                                        {/* <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'arial',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                Email:<span className="mymail">{userdata.email}</span>
                                            </td>
                                        </tr> 
                                        <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                P.O Box: 84270 Riyadh 11671
                                            </td>
                                            <td width="5"></td>
                                        </tr>*/}
                                        <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                {activeData.addressone}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                {activeData.addresstwo}
                                            </td>
                                            <td width="5"></td>
                                        </tr>
                                        <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                {activeData.phonenumber}
                                            </td>

                                        </tr>
                                        <tr>
                                            <td
                                                className="mydata"
                                                style={{
                                                    fontFamily: 'system-ui',
                                                    fontSize: '8pt',
                                                    color: '#000',
                                                    lineHeight: '16px',
                                                }}
                                            >
                                                <span className="mymob"><a href={activeData.siteLink} target="_blank">{activeData.siteText}</a></span>
                                            </td>
                                            <td width="5"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td width="5"></td>
                        </tr>
                        <tr>
                            <td colSpan="4" height="20"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <button className='btnss' onClick={() => { copyContent() }}>Copy Signatures</button>
        </div>

    )
}

export default Home



